module.exports = __webpack_public_path__ + "img/6.3d70e2c5.jpg";